export default {
    nav: {
        assets: "资产中心",
        benefits: "全部权益",
        code: "礼品卡",
    },
    benefits: {
        money: "货币",
        k_coin: "K币余额",
        points: "积分",
        level: "等级",
        coin: "币",
        exp: "经验值",
        recharge: "立即充值",
        points_history: "积分变动记录",
        exp_history: "等级成长记录",
        opened_service: "已开通的服务",
        expired_at: "到期时间",
        renew: "立即续费",
        reopen: "重新开通",
        no_service: "暂无已开通的服务",
        kind: "类型",
        change_count: "变动数量",
        created_at: "变动时间",
        kind_map: {
            exp: "经验值",
            points: "积分",
            vip0001: "等级",
            k_coin: "K币",
            o_coin: "O币",
            g_coin: "G币",
        },
    },
    level: {
        1: "青铜",
        2: "白银",
        3: "黄金",
        4: "铂金",
        5: "钻石",
        6: "黑钻",
        7: "臻享",
        8: "至臻",
    },
    purchase: {
        upgrade_account: "升级您的账号",
        upgrade_account_en: "Upgrade your account",
        select_package: "选择规格",
        selected: "已选",
        pay_immediately: "立即支付",
        original_price: "原价",
        discount: "优惠",
        total_discount: "已优惠",
        unit: "元",
        off: "折",
        no_discount: "无折扣",
        agreement_tip1: "本虚拟商品无退货服务",
        agreement_tip2: "获取的权益以实际支付金额为准",
        total: "合计",
    },
    voucher: {
        all: "全部",
        unused: "未使用",
        used: "已使用",
        expired: "已作废",
        exchanged: "已兑换",
        unexchanged: "未兑换",
        unusedCount: "可用数量",
        totalCount: "总计",
        expiryDate: "有效期至",
        hideContent: "隐藏内容",
        showContent: "显示内容",
        copied: "已复制",
        copy: "复制",
        supportTitle: "遇到兑换问题？",
        supportDesc: "如果您的激活码无法使用，请联系系统管理员或查阅常见问题解答。",
        contactSupport: "联系支持中心",
        passwordPromptMsg: "请输入安全密码以查看激活码",
        passwordPromptTitle: "安全验证",
        passwordPlaceholder: "请输入密码",
        passwordRequired: "密码不能为空",
        tokenError: "未能获取安全令牌",
        authFailed: "身份验证失败",
        decryptFailed: "解密失败，请重试",
        tokenExpired: "安全令牌已过期，请重新验证",
        fetchError: "获取激活码失败",
    },
};
